module.exports = __webpack_public_path__ + "13122b11d20e98de711873dd3f42d939.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/avec/img/top_logo.png
// module id = 1759
// module chunks = 1